import { FBX_MODEL, Loader, TEXTURE } from "@g.frame/common.loaders";
import { ViewerModule } from "@g.frame/core";
import { Mesh, MeshBasicMaterial, MeshPhongMaterial, MeshStandardMaterial, SphereBufferGeometry } from "three";
import CowComponent from "../CowComponent/CowComponent";
const texConfig = {
    'SM_AlchemyWoodTable004': 'alchemy_table/alchemy_table_2k_bake.png',
    'road004': 'street_road/road_02_512_bake.png',
    'Small_Ladder': 'small_ladder/small_ladder_512_bake.png',
    'Ladder004': 'ladder/ladder_512_bake.png',
    'metal_tray001': 'metal_tray/metal_tray_512_bake.png',
    // fence
    'Fence1009': 'fence/fence_01_1k_bake.png',
    'Fence1008': 'fence/fence_01_1k_bake.png',
    'Fence4006': 'fence/fence_02_1k_bake.png',
    'Fence4007': 'fence/fence_02_1k_bake.png',
    'Fence4009': 'fence/fence_02_1k_bake.png',
    'Fence4008': 'fence/fence_02_1k_bake.png',
    'Fence3009': 'fence/fence_03_1k_bake.png',
    'Fence3005': 'fence/fence_03_1k_bake.png',
    'Fence3007': 'fence/fence_03_1k_bake.png',
    'Fence3008': 'fence/fence_03_1k_bake.png',
    'Fence5004': 'fence/fence_05_1k_bake.png',
    'Fence2004': 'fence/fence_06_1k_bake.png',
    'FenceGateClosed008': 'fence/fence_07_1k_bake.png',
    'FenceGateClosed009': 'fence/fence_07_1k_bake.png',
    'FenceGateOpen004': 'fence/fence_04_1k_bake.png',
    // barn
    'Barn_Building005': 'barn/outside_barn_bake_2k.png',
    'Barn_Door_1004': 'barn/barn_door_01_1k_bake.png',
    'Barn_Door_2004': 'barn/barn_door_02_1k_bake.png',
    'Barn_Window_2004': 'barn/barn_window_02_1k_bake.png',
    'Barn_Window_1004': 'barn/barn_window_01_1k_bake.png',
    'roof_trim002': 'barn/roof_trim_2K_bake.png',
    'Windows002': 'barn/windows_1K_bake.png',
    'Wooden_Framework004': 'barn/wooden_frame_1k_bake.png',
    'barn_inner_walls002': 'barn/barn_inner_walls_512_bake.png',
    // trash
    'trash_body001': 'trash_bin/trash_body_512_bake.png',
    'transparent_cover001': 'trash_bin/transparent_cover_512_bake.png',
    'trash_cover001': 'trash_bin/trash_cover_512_bake.png',
    'trash_bag001': 'trash_bin/trash_bag_256_bake.png',
    // corn
    'corn_card148': 'corn_cards/corn_stalk_card_2k_bake.png',
    'corn_card149': 'corn_cards/corn_stalk_01_card_2k_bake.png',
    'corn_card165': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card166': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card152': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card153': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card155': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card160': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card161': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card154': 'corn_cards/corn_stalk_04_card_2k_bake_.png',
    'corn_card182': 'corn_cards/corn_stalk_card_05_1k_bake.png',
    'corn_card183': 'corn_cards/corn_stalk_card_05_1k_bake.png',
    'corn_card184': 'corn_cards/corn_stalk_card_06_1k_bake.png',
    'corn_card185': 'corn_cards/corn_stalk_card_06_1k_bake.png',
    'Windmill_Wood004': 'windmill/windmill_wood_2k_bake.png',
    'Windmill_Parts004': 'windmill/windmill_parts_256_bake.png',
    'Windmill_Wheel004': 'windmill/mill_wheel_1k_bake.png',
    // tractor
    'front_wheels004': 'tractor/tractor_front_wheels_2k_bake.png',
    'rear_wheels004': 'tractor/tractor_rear_wheels_2k_bake.png',
    'main_body007': 'tractor/tractor_4k_bake.png',
    // 'coolant_liquid003': 'tractor/tractor_4k_bake.png',
    'tire_inflation_gauge003': 'tractor/coolant_gauge_256_bake.png',
    'coolant_gauge003': 'tractor/coolant_gauge_256_bake.png',
    'oil_gauge003': 'tractor/coolant_gauge_256_bake.png',
    'tie_gauge_indicator003': 'tractor/coolant_gauge_indicator_64_bake.png',
    'oil_gauge_indicator003': 'tractor/coolant_gauge_indicator_64_bake.png',
    'coolant_gauge_indicator003': 'tractor/coolant_gauge_indicator_64_bake.png',
    'tire_inflation_gauge_stem003': 'tractor/coolant_gauge_stem_512_bake.png',
    'oil_gauge_stem003': 'tractor/coolant_gauge_stem_512_bake.png',
    'coolant_gauge_stem003': 'tractor/coolant_gauge_stem_512_bake.png',
    'coolant_tank004': 'tractor/coolant_tank_512_bake.png',
    'coolant_tank_cap004': 'tractor/coolant_tank_cap_128_bake.png',
    'oil_needle004': 'tractor/oil_stick_1k_bake.png',
    'fuel_tank_window003': 'tractor/fuel_window_512_bake.png',
    'oil_valve004': 'tractor/oil_valve_256_bake.png',
    'engine_covering004': 'tractor/engine_inside_backing_4k_bake.png',
    'engine_compartment_door004': 'tractor/engine_compartment_door_4K_bake.png',
    'compartment_knob004': 'tractor/compartment_knob_512_bake.png',
    'Wood_board004': 'woodboard/Wood_board_2k_bake.png',
    'Hay_Cube004': 'hay_bale/hay_bale_1k_bake.png',
    // hut
    'Hut004': 'hut/hut_2k_bake.png',
    'trough002': 'hut/trough_01_512_BAKE.png',
    'trough_01002': 'hut/trough_01_512_BAKE.png',
    'trough_02002': 'hut/trough_02_512_bake.png',
    'trough_03002': 'hut/trough_02_512_bake.png',
    'round_stool008': 'hut/round_stool_256_bake.png',
    'round_stool009': 'hut/round_stool_256_bake.png',
    'Bucket004': 'hut/bucket_256_bake.png',
    'bucket_small_flat004': 'hut/bucket_small_flat_256_bake.png',
    'Watertower004': 'water_tower/water_tower_1k_bake.png',
    // waggon
    'Waggon_Body004': 'wagon/wagon_2k_bake.png',
    'Waggon_Clutch004': 'wagon/wagon_hitch_512_bake.png',
    'Wheel_Waggon_RL004': 'wagon/wagon_rear_left_wheel_512_bake.png',
    'Wheel_Waggon_RR004': 'wagon/wagon_rear_right_wheel_256_bake.png',
    'Waggon_suspension_Front004': 'wagon/wagon_axel_256_bake.png',
    'Wheel_Waggon_FL004': 'wagon/wagon_left_front_wheel_512_bake.png',
    'Wheel_Waggon_FR004': 'wagon/wagon_front_right_wheel_256_bake.png',
    'Hoe004': 'hoe/hoe_512_Bake.png',
    'Fork004': 'fork/fork_512_bake.png',
    'Barrel004': 'barrel/barrel_512_bake.png',
    'Rake004': 'rake/rake_512_bake.png',
    'Shovel': 'shovel/shovel_512_bake.png',
    'Cart004': 'wheel_barrel/wheel_barrel_512_bake.png',
    'dirt_outer': 'dirt_outer/dirt_outer_4K_bake.png',
    'dirt_inner': 'dirt_inner/dirt_inner_4k_bake.png',
    'well002': 'well/well_1k_bake.png',
    'well_bucket002': 'well/well_bucket_256_bake.png',
};
const alphaMaps = {
    'corn_card148': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card149': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card165': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card166': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card152': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card153': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card155': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card160': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card161': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card154': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card182': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card183': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card184': 'corn_cards/cornstalk_card_alpha.png',
    'corn_card185': 'corn_cards/cornstalk_card_alpha.png',
    'main_body007': 'tractor/tractor_opacity_bake_1k.png',
    'coolant_tank004': 'tractor/tractor_opacity_bake_1k.png',
};
export default class Environment extends ViewerModule {
    constructor(modulesProcessor) {
        super();
        this.modulesProcessor = modulesProcessor;
        this.loader = this.modulesProcessor.agents.get(Loader);
        this.loader.addResources([
            {
                name: 'MODEL_environment',
                url: require('../../../assets/models/environment/farm_scene.fbx'),
                type: FBX_MODEL
            },
            {
                name: 'TEXTURE_background',
                url: require('../../../assets/textures/env/HDRI/mealie_road.jpg'),
                type: TEXTURE
            },
        ]);
        this.cowComponent = new CowComponent(this.modulesProcessor);
        const textures = [];
        for (let key in texConfig) {
            textures.push({
                name: 'TEXTURE_' + key,
                url: require(`../../../assets/textures/env/${texConfig[key]}`),
                type: TEXTURE
            });
        }
        for (let key in alphaMaps) {
            textures.push({
                name: 'TEXTURE_alpha_' + key,
                url: require(`../../../assets/textures/env/${alphaMaps[key]}`),
                type: TEXTURE
            });
        }
        // const textures_ = texConfig.map((item) => {
        //     return {
        //         name: 'TEXTURE_' + item.name,
        //         url: require(`../../../assets/textures/env/${item.path}`),
        //         type: TEXTURE
        //     }
        // });
        this.loader.addResources(textures);
    }
    init() {
        this.environment = this.loader.getResource('MODEL_environment');
        this.environment.scale.set(0.01, 0.01, 0.01);
        this.addObject(this.environment);
        this.prepareMaterials();
        this.hideElements();
        this.addBackground();
        this.initCow();
    }
    initCow() {
        this.cowComponent.init();
        this.addObject(this.cowComponent);
    }
    prepareMaterials() {
        this.environment.traverse((child) => {
            if (child && child.material) {
                if (child.name === 'coolant_liquid003') {
                    const mat = new MeshStandardMaterial({
                        color: '#9b1f1f',
                    });
                    child.material = mat;
                    child.position.set(101.625, 110.10649871826172, 608.1015625);
                    child.scale.z = 3.451304960250855;
                }
                if (child.name === 'coolant_tank004') {
                    const mat = new MeshPhongMaterial({
                        opacity: 0.5,
                        color: '#333333',
                        transparent: true,
                    });
                    child.material = mat;
                }
                else if (texConfig[child.name]) {
                    const mat = new MeshBasicMaterial({
                        map: this.loader.getResource('TEXTURE_' + child.name),
                        side: 2,
                        transparent: false,
                    });
                    if (alphaMaps[child.name]) {
                        mat.alphaMap = this.loader.getResource('TEXTURE_alpha_' + child.name);
                        mat.transparent = true;
                        mat.needsUpdate = true;
                    }
                    child.material = mat;
                }
                if (child.name === 'metal_tray001') {
                    const newTray = child.clone();
                    newTray.name = 'metal_tray_02';
                    newTray.position.set(265, 76, -1040);
                    newTray.scale.set(35, 20, 0.78);
                    this.environment.add(newTray);
                }
                if (child.name === 'corn_card152' || child.name === 'corn_card182' || child.name === 'corn_card148' || child.name === 'corn_card154') {
                    //@ts-ignore
                    child.material.depthWrite = false;
                    //@ts-ignore
                    child.material.needsUpdate = true;
                }
            }
        });
    }
    addBackground() {
        const sphere = new Mesh(new SphereBufferGeometry(300, 24, 24), new MeshBasicMaterial({
            map: this.loader.getResource('TEXTURE_background'),
            side: 1
        }));
        this.addObject(sphere);
    }
    hideElements() {
        const hideElements = ['tablet', 'screen', 'Framework_Screw_Details', 'ground', 'road_back', 'Light004'];
        // const list = ['Cube', 'tablet', ];
        this.environment.traverse((child) => {
            if (hideElements.includes(child.name)) {
                child.visible = false;
            }
        });
    }
}
